
import ReceiptSearch from "../../../assets/outline/ReceiptSearch.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiptSearchIcon({ className, dataTestid = "ReceiptSearchIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiptSearch data-testid={dataTestid} className={classes} {...rest} />
  );
}
